module.exports = __webpack_public_path__ + "img/Trendyol.b621a72f.png";